import { classNamePrefix, TextRenderer } from 'cdk-radial';
import classNames from 'classnames';

const componentMainClass = `${classNamePrefix}-table`;
const agGridThemeClass = 'ag-theme-balham';
const dealerIntegationTableClass = 'dealer-integration__table';
const dmsConfigTableClass = 'dmsconfig__table';

export const dealerIntegrationsTableClass = classNames(componentMainClass, agGridThemeClass, dealerIntegationTableClass);
export const dmsConfigsTableClass = classNames(agGridThemeClass, dmsConfigTableClass);
export const frameworkComponentsExtended = {
    textRenderer: TextRenderer
};

export const createChunks = (chunkSize, list = []) => {
    const chunks = [];
    for (let i = 0; i < list.length; i += chunkSize) {
      const chunk = list.slice(i, i + chunkSize);
      chunks.push(chunk);
    }
    return chunks;
};